var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 31.9987C24.8354 31.9987 31.9978 24.8363 31.9978 16.001C31.9978 7.16575 24.8354 0.00335693 16.0001 0.00335693C7.16484 0.00335693 0.00244141 7.16575 0.00244141 16.001C0.00244141 24.8363 7.16484 31.9987 16.0001 31.9987Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14554 8.00208C1.42346 9.2526 0.890828 10.56 0.536133 11.8917L27.2903 27.3384C28.2663 26.3653 29.1323 25.2502 29.8542 23.9997L2.14554 8.00208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 2.14664C17.5972 -1.549 9.70453 -0.317285 4.70898 4.66357L31.4632 20.1101C33.279 13.2936 30.3993 5.84235 23.9983 2.14664V2.14664Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00089 29.8553C14.4019 33.551 22.2948 32.3193 27.2902 27.3385L0.535919 11.8918C-1.27981 18.7085 1.59975 26.1597 8.00089 29.8553Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5213 14.2622C20.5213 16.759 18.4972 18.7832 16.0002 18.7832C13.5033 18.7832 11.4791 16.7591 11.4791 14.2622C11.4791 13.4836 11.6759 12.7511 12.0226 12.1115C11.0415 13.1148 10.4358 14.4868 10.4358 16.001C10.4358 19.0741 12.927 21.5654 16.0002 21.5654C19.0734 21.5654 21.5647 19.0742 21.5647 16.001C21.5647 14.4868 20.959 13.1148 19.9779 12.1115C20.3245 12.7512 20.5213 13.4836 20.5213 14.2622V14.2622Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9572 9.04559H17.0438V19.4789H14.9572V9.04559Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4782 11.1322H12.5227C12.5227 11.6124 12.941 12.0016 13.4212 12.0016H13.3922C13.3922 12.4818 13.7815 12.8711 14.2616 12.8711C14.2616 13.3513 14.6509 13.7405 15.1311 13.7405H16.8699C17.3501 13.7405 17.7394 13.3513 17.7394 12.8711C18.2196 12.8711 18.6088 12.4818 18.6088 12.0016H18.5799C19.0599 12.0016 19.4782 11.6124 19.4782 11.1322Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1316 20.1745H20.8693V22.2612H11.1316V20.1745Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 20.8699H22.2602V22.9566H18.0869V20.8699Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74036 20.8699H13.9136V22.9566H9.74036V20.8699Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBn);
export default __webpack_public_path__ + "static/media/BN.7777ea06.svg";
export { ForwardRef as ReactComponent };